import React from 'react';
import { Box,Typography } from '@mui/material';
import {useNavigate} from 'react-router-dom'
import logoImage from '../../assets/images/logos/logo.png';

const Logo = () => {

  return (
    <Box sx={{  display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'10px',cursor:'pointer'}}>
          <img src={logoImage} alt="Logo" width="50" height="50"/>
         <Box  sx={{lineHeight:'0.2rem'}}>
          <Typography  sx={{ fontWeight: 'bold', fontSize: '1.25rem', color: '#784e3c', fontFamily: 'Achiko'}}>
             baoubab
          </Typography>
          <Typography sx={{  fontSize: '0.5rem', color: '#784e3c', marginTop: -1 }}>By bokonzi</Typography>
         </Box>


          </Box>
  );
};

export default Logo;
